import { Home, Layers, Check } from "lucide-react";

const SERVICES = [
  {
    id: "custom-homes",
    icon: Home,
    title: "Custom Homes",
    img: "/images/custom_home_modern.jpg",
    text: "From the foundation to the final walkthrough, we build the home you've been picturing — on your land, to your plans, with a builder you can actually reach.",
    points: ["Foundations & framing", "Ground-up custom builds", "Additions & ADUs", "Project updates in your portal"],
  },
  {
    id: "custom-concrete",
    icon: Layers,
    title: "Custom Concrete Work",
    img: "/images/concrete_patio_shadows.jpg",
    text: "Concrete done right for the desert: properly prepped, reinforced and finished to last through the heat, wind and cold.",
    points: ["Slabs & foundations", "Driveways & walkways", "Stamped & decorative patios", "Retaining & block walls"],
  },
];

export const Services = () => (
  <section id="services" className="border-t border-[#E6E2DA] bg-white py-16 sm:py-24 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <p className="eyebrow mb-3">What we build</p>
      <h2 className="font-display max-w-2xl text-3xl font-bold tracking-tight sm:text-4xl">Two crafts. One standard: solid from the ground up.</h2>
      <div className="mt-12 grid gap-8 md:grid-cols-2">
        {SERVICES.map((s) => (
          <article key={s.id} data-testid={`service-card-${s.id}`} className="group overflow-hidden rounded-2xl border border-[#E6E2DA] bg-[#FAF8F5] transition-colors duration-200 hover:border-[#A67C00]/50">
            <div className="h-64 overflow-hidden">
              <img src={s.img} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-6 sm:p-8">
              <div className="mb-3 flex items-center gap-3">
                <s.icon className="text-[#A67C00]" size={22} />
                <h3 className="font-display text-2xl font-bold">{s.title}</h3>
              </div>
              <p className="leading-relaxed text-[#4A4742]">{s.text}</p>
              <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {s.points.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm font-medium"><Check size={15} className="text-[#A67C00]" />{p}</li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
